<mat-card>
    <mat-card-header>
        <mx-button id="backButton" style="order: -1" [buttonModel]="backButton"></mx-button>
        <mat-card-title>{{getLabel('label.menu.dashboard')}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div>
            <mx-text-field [form]="form" name="subject" [label]="getLabel('label.dashboard.message.subject')"></mx-text-field>
        </div>
        <div class="regular-wrapper">
            <div class="chat-window" #scrollMe>
                <div [ngClass]="msg.userSend ? 'bubble-right' : 'bubble-left'" *ngFor="let msg of messages">
                    <div class="bubble-item" [ngClass]="{'bubble-item-right': msg.userSend === true,
                 'bubble-item-left': msg.userSend === false}">
                        <p><b>{{msg.user}} ({{ msg.date | zoneDate: dateTimeFormat}})</b></p>
                        <p class="msg-text">{{msg.message}}</p>
                    </div>
                </div>
            </div>
            @if (!isGlobal) {
                <div>
                    <mx-text-area-field [form]="messageForm" name="message" [label]="getLabel('label.dashboard.message.message')" fitContent=true>
                    </mx-text-area-field>
                    <div *ngIf="messageForm.get('message')?.errors?.['maxlength']" class="error"></div>
                </div>
            }
        </div>
    </mat-card-content>
    <div>
        @if (!isGlobal) {
            <mat-card-actions>
                <mx-button [buttonModel]="sendButton"></mx-button>
            </mat-card-actions>
        }
    </div>
</mat-card>
